/* eslint-disable */
(function () {
    function closeTopBanner(event) {
        const topBanner = window.BryanAnthonysTopBanner;
        if (!topBanner || !topBanner.body_classes) {
            return;
        }

        topBanner.body_classes.forEach(cssClass => document.body.classList.remove(cssClass));
        document.body.classList.remove('has-banner-top-banner');

        const bannerElement = event.target.closest('.ba_top_banner');
        bannerElement.remove();
        document.querySelectorAll('.ba_top_banner_placeholder').forEach(placeholder => placeholder.remove());
        document.querySelectorAll('#ba-top-banner-css').forEach(placeholder => placeholder.remove());

        if (topBanner.hideStorageKey) {
            localStorage.setItem(topBanner.hideStorageKey, 'true');
        }

        if (topBanner.clockInterval) {
            clearInterval(topBanner.clockInterval);
        }
    }

    document.querySelectorAll('.ba_top_banner_close')
        .forEach(button => button.addEventListener('click', closeTopBanner));

    function startBannerCountdown (banner) {
        const bannerElement = document.getElementById(banner.css_id);
        const timerElement = bannerElement.querySelector('[data-is-clock="true"]');
        if (!timerElement) {
            return null;
        }

        const hours = timerElement.querySelector('.ba-clock-hours .ba-clock-number');
        const minutes = timerElement.querySelector('.ba-clock-minutes .ba-clock-number');
        const seconds = timerElement.querySelector('.ba-clock-seconds .ba-clock-number');

        setBannerEndTime();
        const initialTime = getTimeRemaining(banner.end_time_ms);

        if (initialTime.total < 0) {
            setCountdownAtZero();

            return;
        }

        clockTick();

        timerElement.classList.add('countdown-has-started');

        function setCountdownAtZero() {
            hours.innerText = '00';
            minutes.innerText = '00';
            seconds.innerText = '00';
        }

        function clockTick() {
            const time = getTimeRemaining(banner.end_time_ms);
            if (time.total < 0) {
                stopCountdown();

                return;
            }

            if (hours.innerText !== String(time.hours)) {
                if (time.hours < 10) {
                    time.hours = '0' + String(time.hours);
                }

                hours.innerText = time.hours;
            }

            if (minutes.innerText !== String(time.minutes)) {
                if (time.minutes < 10) {
                    time.minutes = '0' + String(time.minutes);
                }

                minutes.innerText = time.minutes;
            }

            if (time.seconds < 10) {
                time.seconds = '0' + String(time.seconds);
            }
            seconds.innerText = time.seconds;
        }

        banner.clockInterval = setInterval(clockTick, 1000);

        function stopCountdown() {
            setCountdownAtZero();
            clearInterval(banner.clockInterval);
            banner.hideStorageKey = null;
            document.querySelector('.ba_top_banner_close').click();
        }

        function getTimeRemaining(endtime) {
            const total = endtime - Date.parse(new Date());
            const seconds = Math.floor((total / 1000) % 60);
            const minutes = Math.floor((total / 1000 / 60) % 60);
            const hours = Math.floor(total / (1000 * 60 * 60));

            return {
                total: total,
                seconds: seconds,
                minutes: minutes,
                hours: hours
            };
        }

        function setBannerEndTime() {
            banner.end_time_ms = banner.end_time * 1000;
            if (timerElement.dataset.countdownTo === 'daily') {
                const total_time_left = banner.end_time_ms - Date.parse(new Date());
                const days_left = total_time_left / (1000 * 60 * 60 * 24);
                if (days_left > 1) {
                    banner.end_time_ms -= 1000 * 60 * 60 * 24 * Math.floor(days_left);
                }
            }
        }
    }

    startBannerCountdown(window.BryanAnthonysTopBanner);

    document.querySelectorAll('[data-attentive-creative-id]').forEach(attentiveLink => {
        attentiveLink.href = '/';
        attentiveLink.setAttribute('role', 'button');
        attentiveLink.setAttribute('aria-haspopup', 'dialog');
        attentiveLink.addEventListener('click', event => {
            event.preventDefault();
            let creativeId = attentiveLink.dataset.attentiveCreativeId;

            const isInternationalVisitor = BryanAnthonys.isInternationalVisitor();
            const isDomesticVisitor = !isInternationalVisitor;
            const isMobile = BryanAnthonys.device.isMobile();
            const isDesktop = !isMobile;

            switch (true) {
                case Boolean(isDomesticVisitor && isDesktop && attentiveLink.dataset.attentiveCreativeIdDesktop):
                    creativeId = attentiveLink.dataset.attentiveCreativeIdDesktop;
                    break;
                case Boolean(isInternationalVisitor && isMobile && attentiveLink.dataset.attentiveCreativeIdIntl):
                    creativeId = attentiveLink.dataset.attentiveCreativeIdIntl;
                    break;
                case Boolean(isInternationalVisitor && isDesktop && attentiveLink.dataset.attentiveCreativeIdIntlDesktop):
                    creativeId = attentiveLink.dataset.attentiveCreativeIdIntlDesktop;
                    break;
            }

            window.__attentive.trigger(null, null, null, creativeId);
        });
    });
})();